module.exports = __webpack_public_path__ + "img/vertical_3_1_7042.56a71980.png";